import { useState, useMemo } from 'react'
import get from 'lodash/get'

import { LOCATION_FILTER } from 'Constants/ids'

const useLocationFilter = services => {
  const [selectedLocation, setSelectedLocation] = useState(null)

  const handleChangeLocation = location => {
    const locationValue = location?.value
    setSelectedLocation(
      locationValue === LOCATION_FILTER.ALL ? null : locationValue,
    )
  }

  const filteredServices = useMemo(() => {
    if (!selectedLocation || selectedLocation === LOCATION_FILTER.ALL) {
      return services
    }

    return services.filter(service => {
      const serviceLocations = get(service, 'locations', [])
      return serviceLocations.some(
        location => get(location, 'name') === selectedLocation,
      )
    })
  }, [services, selectedLocation])

  return {
    filteredServices,
    handleChangeLocation,
    selectedLocation,
  }
}

export default useLocationFilter
